// extracted by mini-css-extract-plugin
export default {"button":"MenuMyCard_button__QA3Nh","iconDropDown":"MenuMyCard_iconDropDown__HOvln","descrDropDown":"MenuMyCard_descrDropDown__+Upmq"};